<template>
  <el-dialog
    custom-class="fin-dialog"
    title="概算经评"
    visible
    fullscreen
    :modal="false"
    :before-close="close"
  >
    <el-container>
      <el-aside width="200px">
        <el-menu :default-active="defaultActive" @select="select">
          <el-menu-item index="estimate">
            <span slot="title">概算</span>
          </el-menu-item>
          <el-menu-item index="economic">
            <span slot="title">经评</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-main>
        <router-view name="content"></router-view>
      </el-main>
    </el-container>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: Boolean
  },
  data() {
    //console.log(this.$route);
    return {
      modal: false,
      defaultActive: this.$route.name
    };
  },
  watch: {},
  methods: {
    select(name) {
      this.$router.replace({
        name,
        query: {
          windfarmId: this.$route.query.windfarmId,
          projectId: this.$route.query.projectId
        }
      });
    },
    close() {
      this.$router.push({
        name: 'project-detail',
        query: {
          projectId: this.$route.query.projectId
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.fin-dialog {
  border-radius: 0;

  /deep/.el-dialog__header {
    border-radius: 0;
  }

  /deep/.el-dialog__body {
    padding-left: 0;
    padding-right: 0;
    height: calc(100% - 54px);
    box-sizing: border-box;
  }

  /deep/.el-container {
    height: 100%;
  }

  /deep/.el-main {
    padding: 0 10px;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
  }

  /deep/.el-tabs {
    height: 100%;

    .el-tabs__content {
      overflow-y: auto;
      height: calc(100% - 40px);
      // padding-bottom: 50px;
    }
  }

  /deep/.el-menu {
    background-color: #32323a;
    border-right: none;

    .el-menu-item {
      color: #fff;
      &:focus,
      &:hover {
        background-color: #3c3d45;
      }
      &.is-active {
        background-color: #015cad;
      }
    }
  }

  /deep/.el-aside {
    background: #32323a;
  }
}
</style>
